import { render, staticRenderFns } from "./ItemsSelectionDialog.vue?vue&type=template&id=5e2365b6"
import script from "./ItemsSelectionDialog.vue?vue&type=script&lang=js"
export * from "./ItemsSelectionDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports